import classNames from 'classnames';
import Text from '../atoms/text';
import SVGIcon from '../atoms/icons';

interface ModalProps extends React.HTMLAttributes<HTMLDivElement> {
	isModalVisible: boolean;
	onClose: () => void;
	hideClose?: boolean;
}
const Modal = ({
	isModalVisible,
	onClose,
	title,
	children,
	className,
	hideClose = false,
	...props
}: ModalProps) => {
	const onOverlayClick = () => {
		onClose();
	};

	return (
		<div className="relative">
			<div
				className={classNames(
					'fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-10 transition-opacity',
					{ hidden: !isModalVisible }
				)}
				aria-hidden={!isModalVisible}
				onClick={onOverlayClick}
			/>
			<div
				className={classNames(
					'fixed grid p-4 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md shadow-lg max-w-[95%] w-[36rem] max-h-[95%] overflow-auto z-20',
					{
						hidden: !isModalVisible,
						'bg-white': !className?.includes('bg-'),
					},
					className
				)}
				aria-modal={isModalVisible}
				role="dialog"
				{...props}
			>
				<div className="flex justify-between">
					<Text className="text-primary" as="h4">
						{title}
					</Text>
					{!hideClose && (
						<SVGIcon
							className="w-4 h-auto fill-gray-label cursor-pointer"
							icon="X"
							onClick={onClose}
						/>
					)}
				</div>
				{children}
			</div>
		</div>
	);
};

export default Modal;
